/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./SignupPasswordAgain.css";
import { simpleFetch } from "../../restWrapper";
import { Link } from "react-router-dom";
import { validSignupDonor } from "../../assets/validators/donorInfo.js";
import errorMsg from "../../assets/json/errMsg.json";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import "react-phone-number-input/style.css";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";

class SignupPasswordAgain extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.state === undefined) {
      if (this.props.history.length <= 1) {
        this.props.history.push("/");
        return;
      } else {
        this.props.history.push("/loginEmail");
        return;
      }
    }

    this.state = {
      username: this.props.location.state.username,
      password: this.props.location.state.password,
      confirmPassword: "",
      errMsgs: [],
      isSubmitting: false,
    };

    this._handleFirstName = (e) => {
      this.setState({
        firstName: e.target.value,
      });
    };
    this._handleLastName = (e) => {
      this.setState({
        lastName: e.target.value,
      });
    };
    this._handlePhone = (e) => {
      this.setState({
        phone: e.target.value,
      });
    };
    this._handlePwChange = this._handlePwChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  _handlePwChange(event) {
    this.setState({
      ...this.state,
      ...{
        confirmPassword: event.target.value,
      },
    });
  }

  reroute() {
    if (this.state.isSubmitting) return null;

    const isValidInfo = validSignupDonor(this.state, this.props.language);

    if (!isValidInfo.isValid) {
      this.setState({
        errMsgs: isValidInfo.msgs,
      });
      return null;
    }

    this.setState({ isSubmitting: true });

    // Pass isCustomDomain so simpleFetch sends x-checkplus-external and the
    // backend returns a JWT (required for /donors/verify-code). Same as the
    // seamless registration path in PersonalDetails.
    simpleFetch(
      "/donors/register",
      "POST",
      {
        username: this.state.username,
        password: this.state.password,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        phoneNumber: this.state.phoneNumber,
        language: this.props.language,
      },
      false,
      { isCustomDomain: true }
    ).then((res) => {
      // Backend returns 200 with JWT + message, or legacy 204 with no body.
      // Treat both as success — otherwise the success message is shown as an error.
      if (res.status === 200 || res.status === 204) {
        if (res.status === 200 && res.body && res.body.accessToken) {
          localStorage.setItem("accessToken", res.body.accessToken);
          localStorage.setItem("expiredIn", res.body.expiredIn);
          if (res.body.emailVerified !== undefined) {
            localStorage.setItem(
              "emailVerified",
              res.body.emailVerified.toString()
            );
          }
        }

        this.props.history.push({
          pathname: "/EmailVerification",
          state: {
            color: this.props.location.state.color,
            logoStyle: this.props.location.state.logoStyle,
            organizationName: this.props.location.state.organizationName,
          },
        });
      } else {
        this.setState({
          isSubmitting: false,
          errMsgs: [
            (res.body && res.body.message) ||
              errorMsg[this.props.language].donorInfoErr.registerFailed,
          ],
        });
      }
    }).catch(() => {
      this.setState({
        isSubmitting: false,
        errMsgs: [errorMsg[this.props.language].donorInfoErr.networkErr],
      });
    });
  }

  render() {
    // The constructor already redirects away when location.state is missing
    // (direct visit / refresh wipes it). Bail out of this transitional render
    // so we don't dereference undefined state before that navigation lands.
    if (!this.props.location.state || !this.props.location.state.color) {
      return null;
    }

    const logoStyle = this.props.location.state.logoStyle;

    const languageObj = this.props.languageObj;

    //    const color = this.props.location.state.color;

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const textOverrideStyle = {
      color: "#" + this.props.location.state.color.buttonColor,
    };
    /*
    const buttonOverrideStyle = {
      background: '#' + this.props.location.state.color.headerColor,
      color: '#' + this.props.location.state.color.buttonColor
    };
*/

    const organizationName = this.props.location.state.organizationName;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };

    return (
      <div className="SignupPasswordAgain-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="SignupPasswordAgain-prompt">
          <Link to={"/LoginPrompt"}>
            <div className="SignupPasswordAgain-backContainer">
              <div className="SignupPasswordAgain-back">
                <div className="SignupPasswordAgain-backBtn"></div>
                <div className="SignupPasswordAgain-backText">
                  {languageObj.backBtn}
                </div>
              </div>
            </div>
          </Link>

          <div
            className="SignupPasswordAgain-logoContainer"
            style={backgroundOverrideStyle}
          >
            {logoStyle && (
              <div className="SignupPasswordAgain-logo" style={logoStyle}></div>
            )}
          </div>

          <div className="SignupPasswordAgain-text">{languageObj.text}</div>

          <div className="SignupPasswordAgain-inputFieldContainer">
            <input
              onChange={this._handleLastName}
              type="text"
              className="SignupPasswordAgain-inputField"
              placeholder={languageObj.lastName}
              disabled={this.state.isSubmitting}
            />
          </div>

          <div className="SignupPasswordAgain-inputFieldContainer">
            <input
              onChange={this._handleFirstName}
              type="text"
              className="SignupPasswordAgain-inputField"
              placeholder={languageObj.firstName}
              onKeyDown={handleKeyDown}
              disabled={this.state.isSubmitting}
            />
          </div>

          <div className="SignupPasswordAgain-inputFieldContainer">
            <PhoneInput
              onKeyDown={handleKeyDown}
              placeholder={languageObj.phoneNumber}
              value={this.state.phoneNumber}
              defaultCountry={"HK"}
              flags={flags}
              className="SignupPasswordAgain-inputField"
              disabled={this.state.isSubmitting}
              onChange={(phone) => {
                const no = formatPhoneNumberIntl(phone);
                this.setState({
                  phoneNumber: no,
                });
              }}
            />
          </div>

          <div className="SignupPasswordAgain-inputFieldContainer">
            <div className="SignupPasswordAgain-inputContainerLeft">
              <input
                onChange={this._handlePwChange}
                type="password"
                className="SignupPasswordAgain-inputField"
                placeholder={languageObj.reenterPassword}
                onKeyDown={handleKeyDown}
                disabled={this.state.isSubmitting}
              />
            </div>
            <div className="SignupPasswordAgain-inputContainerRight">
              <div
                onClick={this.reroute}
                className={`SignupPasswordAgain-nextBtn ${this.state.isSubmitting ? "SignupPasswordAgain-nextBtn-disabled" : ""}`}
                style={backgroundOverrideStyle}
              >
                <div
                  className="SignupPasswordAgain-nextText"
                  style={textOverrideStyle}
                >
                  {this.state.isSubmitting
                    ? languageObj.submitting || "Submitting..."
                    : languageObj.submitBtn}
                </div>
              </div>
            </div>
          </div>

          {this.state.errMsgs.map((err) => (
            <div key={err} className="SignupPasswordAgain-errorContainer">
              <div className="SignupPasswordAgain-errorIndicator"></div>
              <div className="SignupPasswordAgain-errorMessage">{err}</div>
            </div>
          ))}

          <div className="SignupPasswordAgain-chin"></div>
        </div>
      </div>
    );
  }
}
SignupPasswordAgain.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};
export default SignupPasswordAgain;
